"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EqualCountRaster = void 0;
const raster_1 = require("./raster");
const helpers_1 = require("./helpers");
class EqualCountRaster extends raster_1.Raster {
    constructor(data, bounds, colorRange, options) {
        super(data, bounds, colorRange, options);
        this.ranges = this.computeRanges();
        this.imageData = this.computeImagedata();
    }
    computeRanges() {
        const ordered = this.orderedValues;
        const bucketCount = this.colors.length;
        return (0, helpers_1.bucketByEqualCount)(ordered, bucketCount);
    }
}
exports.EqualCountRaster = EqualCountRaster;
